import { waitForNotifierEventFactory } from '@/ws/factories';
import { caseNotifier } from '@/ws';

export const waitForCaseEvent = waitForNotifierEventFactory(caseNotifier.once.bind(caseNotifier));
